export const USER_TYPE = 'accounts.organizationuser' as const;
